/**
 * Created by Josef Jurca on 11.10.2017.
 */

const ErrorCodes = {
    ALREADY_PURCHASED: '3024',
    LIMITATION_ERROR: '1014',
    USER_EXISTS: '2014',
    USER_DOES_NOT_EXIST: '2000',
    WRONG_USERNAME_OR_PASSWORD: '1011',
    INSIDE_LOCKTIME: '2015',
    SESSION_EXPIRED: '500016',
    REMINDER_EXISTS: '8023',
    DEVICE_DOES_NOT_EXIST: '1019',
    EXCEEDED_LIMIT: '1001',
    INCORRECT_PASSWORD_OR_LOGIN: '50027'
};

export default ErrorCodes;


// WEBPACK FOOTER //
// ./src/js/errorcodes.js